export default __webpack_public_path__ + "static/hub-teacher-portrait-077b0456366e601275695e1c15cc8e92.jpg";